import { useEffect, useState } from "react";
import { applyUpdate, subscribeToUpdateAvailable } from "../../utils/appUpdate";
import styles from "./updateAvailableBanner.module.scss";
import { useTranslation } from "react-i18next";

// Mounted once, globally, in App.tsx - stays invisible until a deploy is
// detected while the user already has this tab open and in use (see
// src/index.tsx and src/utils/appUpdate.ts for why that case can't just
// auto-reload like a fresh page load does).
function UpdateAvailableBanner() {
    const { t } = useTranslation("common");
    const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

    const [busy, setBusy] = useState(false);
    const [blocked, setBlocked] = useState(false);
    async function refresh() {
        /* istanbul ignore if -- unreachable: the Refresh button that calls this only renders once `registration` is set (see the early return below) */
        if (!registration) return;
        setBusy(true); setBlocked(false);
        try { await applyUpdate(registration); }
        catch { setBlocked(true); }
        finally { setBusy(false); }
    }

    useEffect(() => subscribeToUpdateAvailable(setRegistration), []);

    if (!registration) return null;

    return (
        <div className={styles.banner} role="status">
            <span className={styles.message}>{t("updateBanner.message")}</span>
            <button type="button" className={styles.refreshButton} disabled={busy} onClick={refresh}>
                {t("updateBanner.refresh")}
            </button>
            {blocked && <span role="alert">{t("updateBanner.pending")}</span>}
        </div>
    );
}

export default UpdateAvailableBanner;
